<template>
  <div class="updatastory">
    <!-- <a-row type="flex" justify="space-between" style="margin-bottom: 0px"> -->
    <a-button type="primary" @click="backBefor()"
      ><a-icon type="left-circle"
    /></a-button>

    <a-form :form="form" @submit="handleSubmit">
      <a-form-item v-bind="formItemLayout" extra="当前分类父级">
        <span slot="label">
          父级分类&nbsp;
          <a-icon type="exclamation-circle" />
        </span>
        <a-cascader
          :options="options"
          :field-names="{
            value: 'id',
            label: 'sortName',
            children: 'children',
          }"
          :display-render="displayRender"
          expand-trigger="hover"
          v-decorator="[
            'parentId',
            { rules: [{ required: false, message: '请选择分类' }] },
          ]"
          change-on-select
          @change="onChange"
        />
        <!-- <a-input v-decorator="['parentId']" /> -->
      </a-form-item>

      <a-form-item v-bind="formItemLayout">
        <span slot="label">
          分类名称&nbsp;
          <a-tooltip title="分类名称">
            <a-icon type="menu" />
          </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortName',
            {
              rules: [
                {
                  required: true,
                  message: '请输入分类名称!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout">
        <span slot="label">
          分类别名&nbsp;
          <a-tooltip title="分类别名"> </a-tooltip>
        </span>
        <a-input v-decorator="['sortAlias']" />
      </a-form-item>
      <a-form-item
        v-bind="formItemLayout"
        extra="明确分类作用,加强搜索引擎收录"
      >
        <span slot="label">
          关键字&nbsp;
          <a-tooltip title="关键字"> </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortKeyword',
            {
              rules: [
                {
                  required: true,
                  message: '请输入关键字!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-form-item
        v-bind="formItemLayout"
        extra="明确分类作用,加强搜索引擎收录"
      >
        <span slot="label">
          分类描述&nbsp;
          <a-tooltip title="分类描述"> </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortDescribe',
            {
              rules: [
                {
                  required: true,
                  message: '请输入分类描述!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item
        v-bind="formItemLayout"
        label="操作密码"
        extra="您当前登录的账号内部密码,未设置则不需要填写"
      >
        <a-row :gutter="3">
          <a-col :span="12">
            <a-input-password
              placeholder="操作密码"
              autocomplete
              v-decorator="[
                'captcha',
                {
                  rules: [
                    {
                      message: '请输入您的内部密码！',
                    },
                  ],
                },
              ]"
            />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" hidden>
        <a-input v-decorator="['sortId']" />
      </a-form-item>
      <a-form-item v-bind="tailFormItemLayout">
        <a-switch
          v-decorator="[
            'sortDisabled',
            {
              type: Boolean,
              valuePropName: 'checked',
            },
          ]"
        >
          <a-icon slot="checkedChildren" type="check" />
          <a-icon slot="unCheckedChildren" type="close" />
        </a-switch>
        <span>是否显示</span>
        <!-- <a-checkbox>  </a-checkbox> -->
      </a-form-item>
      <a-form-item v-bind="tailFormItemLayout">
        <a-button
          type="primary"
          icon="check"
          :loading="iconLoading"
          html-type="submit"
        >
          修改
        </a-button>
      </a-form-item>
    </a-form>
    <!-- </a-row> -->
  </div>
</template>

<script>
export default {
  name: "updatastory",
  data() {
    return {
      upData: "",
      iconLoading: false,
      confirmDirty: false,
      /**
       * 父级分了id
       */
      sortParentIdName: [],
      sortParentId: "",
      // residences: [],
      /**
       * 分类数据
       */
      options: [{}],
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  mounted() {
    // console.log(this.$route.params.data);
    this.upData = this.$qs.parse(this.$route.params.data);
    console.log(this.upData);
    this.init();
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.iconLoading = true;
      let $this = this;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // console.log("Received values of form: ", values);
          values.parentId = $this.sortParentId;
          (values.captcha = this.$Encrypt(this.captcha)),
            this.$post("/vr/netuser/sort/updata", values)
              .then(function (response) {
                if (response.code != 1) {
                  $this.iconLoading = false;
                  $this.$message.error(response.msg, 5);
                  return;
                }
                $this.$message.success(
                  "修改" + values.sortName + "分类成功",
                  3
                );
                $this.iconLoading = false;
                $this.backBefor();
              })
              .catch(function (error) {
                console.log(error);
                $this.iconLoading = false;
              });
        } else {
          $this.iconLoading = false;
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },

    init() {
      this.$get("/vr/netuser/sort/select")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.options = response.data;
          this.upDataTreeList(this.options);
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
          console.log(error);
        });
      console.log(!this.upData.disabled);
      this.form.setFieldsValue({
        sortId: this.upData.id,
        sortName: this.upData.sortName,
        sortAlias: this.upData.sortAlias,
        sortKeyword: this.upData.sortKeyword,
        sortDescribe: this.upData.sortDescribe,
        sortDisabled: !JSON.parse(this.upData.disabled),
      });
    },

    upDataTreeList(list) {
      list.map((item) => {
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          this.upDataTreeList(item.children);
        }
        if (item.id == this.upData.id) {
          item.disabled = true;
        }
        let columnArray = [];
        if (item.id == this.upData.parentId) {
          this.sortParentId = item.id;
          if (item.parentId != 0) {
            //间接上级
            columnArray.push(item.parentId);
          }
          //直接父级
          columnArray.push(item.id);
          console.log(columnArray);
          this.form.setFieldsValue({
            parentId: [columnArray, item.sortName, item.sortCode],
          });
          return;
        }
      });
    },
    /**
     * 选择分类
     */
    // onChange(value) {
    //   this.sortParentId = value[value.length - 1];
    //   // console.log(value);
    // },
    // displayRender({ labels }) {
    //   return labels[labels.length - 1];
    // },

    onChange(value) {
      this.sortParentId = value[value.length - 1];
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },

    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
  },
};
</script>

<style lang="less" scoped>
.updatastory {
  width: 100%;
  padding: 10px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/sort/updatastory.vue